import { joinPresence, heartbeatPresence, leavePresence } from "@/api/PresenceApi";

const HEARTBEAT_INTERVAL = 30000; // 30秒

class PresenceService {
  constructor() {
    this.heartbeatTimer = null;
    this.currentSession = null;
    this.onEditorsUpdated = null; // callback
  }

  /**
   * プレゼンスセッションを開始
   */
  async start(siteId, diaryDate, diaryPeriod, userName) {
    this.currentSession = { siteId, diaryDate, diaryPeriod };

    try {
      const response = await joinPresence({
        siteId,
        diaryDate,
        diaryPeriod,
        userName,
      });

      if (this.onEditorsUpdated && response.data.activeEditors) {
        this.onEditorsUpdated(response.data.activeEditors);
      }

      // ハートビート開始
      this.startHeartbeat();
    } catch (error) {
      console.error("プレゼンス開始に失敗:", error);
    }
  }

  /**
   * ハートビートを定期送信
   */
  startHeartbeat() {
    this.stopHeartbeat();
    this.heartbeatTimer = setInterval(async () => {
      if (!this.currentSession) return;
      try {
        const response = await heartbeatPresence({
          siteId: this.currentSession.siteId,
          diaryDate: this.currentSession.diaryDate,
          diaryPeriod: this.currentSession.diaryPeriod,
        });
        if (this.onEditorsUpdated && response.data.activeEditors) {
          this.onEditorsUpdated(response.data.activeEditors);
        }
      } catch (error) {
        console.error("ハートビート送信に失敗:", error);
      }
    }, HEARTBEAT_INTERVAL);
  }

  /**
   * ハートビートを停止
   */
  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
  }

  /**
   * プレゼンスセッションを終了
   */
  async stop() {
    this.stopHeartbeat();
    if (this.currentSession) {
      try {
        await leavePresence({
          siteId: this.currentSession.siteId,
          diaryDate: this.currentSession.diaryDate,
          diaryPeriod: this.currentSession.diaryPeriod,
        });
      } catch (error) {
        console.error("プレゼンス終了に失敗:", error);
      }
      this.currentSession = null;
    }
  }
}

export default new PresenceService();
